import type {RecordRow} from 'src/features/record-grid/lib/types';
import type {Readable} from 'svelte/store';
import type {Rec, UUID} from 'typings/portaro.be.types';
import type {SutorLogbookPairingService} from 'src/features/erp-sutor/pages/project-detail/logbook-pairing/services/sutor-logbook-pairing.service';
import {getContext, hasContext, setContext} from 'svelte';
import {writable} from 'svelte/store';

const sutorLogbookPairingContextKey = 'sutor-logbook-pairing-ctx';

interface SutorLogbookPairingContext {
    service: SutorLogbookPairingService;
    projectRecord: Rec;
    openedLogbook$: Readable<RecordRow | null>;
    processedReports$: Readable<UUID[]>;
    setOpenedLogbook: (logbook: RecordRow | null) => void;
    addProcessedReport: (reportId: UUID) => void;
    removeProcessedReport: (reportId: UUID) => void;
}

export function createSutorLogbookPairingContext(projectRecord: Rec, service: SutorLogbookPairingService): SutorLogbookPairingContext {
    const openedLogbook = writable<RecordRow | null>(null);
    const processedReports = writable<UUID[]>([]);

    return setContext<SutorLogbookPairingContext>(sutorLogbookPairingContextKey, {
        projectRecord,
        service,
        processedReports$: processedReports,
        openedLogbook$: openedLogbook,
        setOpenedLogbook: (logbook) => openedLogbook.set(logbook),
        addProcessedReport: (reportId) => processedReports.update((reports) => [...reports, reportId]),
        removeProcessedReport: (reportId) => processedReports.update((reports) => reports.filter((id) => id !== reportId))
    });
}

export function getSutorLogbookPairingContext(): SutorLogbookPairingContext {
    if (!hasContext(sutorLogbookPairingContextKey)) {
        throw new Error('Sutor logbook pairing context does not exist! Use `createSutorLogbookPairingContext` function to create it in a parent component.');
    }

    return getContext<SutorLogbookPairingContext>(sutorLogbookPairingContextKey);
}